// src/components/DDPaidSuccessfully.js
import React from "react";
import Lottie from "lottie-react";
import successAnimation from "../../assets/animations/Success.json";
const DDPaidSuccessfully = () => {
  return (
    <div className="successfuly mb_80 mt_60">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 text-center m-auto d-flex justify-content-center align-items-center flex-column">
            <Lottie
              animationData={successAnimation}
              loop={true} // plays once
              style={{ width: 200, height: 200 }}
            />
            <h2>DD Paid Successfully</h2>
            <p className="my_20">
              LAZ220 LLC has successfully paid the DD to 15 employees for a total of $18,750.
            </p>
            <a href="#/" className="btn btn_primary">
              Go Back
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DDPaidSuccessfully;
